import { GetDataError } from 'restful-react'
import ElectronIPC from '../../services/ElectronIPC'
import { serializeError } from 'serialize-error'
import { Button } from '@/UIComponents2/Button'
import RefreshIcon from '@/CustomIcons/RefreshIcon'

export default function InternetConnectionError({ error }: { error: GetDataError<any> }) {
    const debugMessage = error?.message || JSON.stringify(serializeError(error))

    return (
        <div className="flex flex-col h-full items-center justify-center">
            <div className="px-8 md:max-w-[600px]">
                <div className="text-xl font-semibold pb-6">Network Error</div>
                <div className="text-sm pb-2">
                    Looks like you are not connected to the internet or Muse is having trouble connecting to one of our
                    servers.
                </div>
                <div className="text-sm pb-2">Please check your internet connection and try again.</div>
                <div className="text-sm pb-8">
                    Details: <span style={{ fontStyle: 'italic' }}>{debugMessage}</span>
                </div>
                <Button variant="link" onClick={() => ElectronIPC.reload()}>
                    <div className="flex items-center gap-1">
                        <span>Retry</span>
                        <RefreshIcon className="py-[2px]" />
                    </div>
                </Button>
            </div>
        </div>
    )
}
